import { render, staticRenderFns } from "./preview-file.vue?vue&type=template&id=68834020&scoped=true"
import script from "./preview-file.vue?vue&type=script&lang=js"
export * from "./preview-file.vue?vue&type=script&lang=js"
import style0 from "./preview-file.vue?vue&type=style&index=0&id=68834020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68834020",
  null
  
)

export default component.exports